import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;

export function useSocial() {
  const [social, setSocial] = useState(cache || { instagram: "", facebook: "", pinterest: "", threads: "", tiktok: "" });
  useEffect(() => {
    if (cache) return;
    api.get("/settings/social").then(({ data }) => { cache = data; setSocial(data); }).catch(() => {});
  }, []);
  return social;
}

export const handleFromUrl = (url) => {
  if (!url) return "";
  const m = url.replace(/\/+$/, "").match(/\/@?([^/?#]+)$/);
  return m ? `@${m[1]}` : url;
};
